module.exports = __webpack_public_path__ + "static/doctor-guide-blood-drop-1126ecb40ecc993b61433235b78f731e.svg";